import { Component, computed, inject, input } from '@angular/core';
import { MatSidenavModule } from '@angular/material/sidenav';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { TranslateModule } from '@ngx-translate/core';
import { bindPageTitle } from '@shared/services/page-title.service';
import { UserStore } from '@signal-store';
import { HeaderComponent } from '@system/header/header.component';
import { MenuComponent } from '@system/menu/menu.component';

const SIDENAV_WIDTH_COLLAPSED = 58;
const SIDENAV_WIDTH_EXPANDED = 250;

@Component({
  selector: 'cipo-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
  imports: [MatSidenavModule, HeaderComponent, MenuComponent, FlexLayoutModule, TranslateModule],
})
export class LayoutComponent {
  userStore = inject(UserStore);
  showHeader = input(true);

  drawerWidth = computed(() => (this.userStore.menu.isCollapsed() ? SIDENAV_WIDTH_COLLAPSED : SIDENAV_WIDTH_EXPANDED));
  drawerWidthClass = computed(() => `cipo cipo--width--${this.drawerWidth()}`);
  contentOffset = computed(() => {
    if (this.userStore.isSmallScreen() || !this.showHeader() || this.userStore.isLoading()) {
      return 0;
    }
    return this.drawerWidth();
  });

  constructor() {
    bindPageTitle(() => {
      if (this.userStore.angularJsRoute()) {
        return undefined;
      }
      return this.userStore.menu.activeMenuItem();
    });
  }

  onDrawerClosed() {
    if (this.userStore.isSmallScreen()) {
      this.userStore.collapseMenu(true);
    }
  }
}
